import OrderItemDetailV2 from './OrderItemDetailV2';

export default OrderItemDetailV2;
